module.exports = __webpack_public_path__ + "img/logo-symbol.cef408e2.png";